import { Box, InputLabel, TextField, useTheme } from '@mui/material'
import { DateRange, DateRangePicker, LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import CancelContractButton from 'components/ui/cancel-contract-button'
import EditIconButton from 'components/ui/edit-icon-buttons'
import DatePickerEditMode from 'components/ui/fields/EditableDatePicker'
import dayjs, { Dayjs } from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import RichTextField from 'components/ContractDialog/MuiRichTextField'
import { useState } from 'react'
import { formatDateTime } from 'utils/formatDayjsDateTime'
import SaveIconButton from '../ui/save-icon-button'
import './OptimizationFields.css'
dayjs.extend(utc)
dayjs.extend(timezone)

const EditOptimizationFields = ({
  localValue,
  optimization,
  addtlNotes,
  onDateRangeChange,
  onChange,
  onBlur,
  onSave,
  onUpdate,
  onCancelEdit,
  onStartEdit,
  isEditMode,
}) => {
  const theme = useTheme()
  const [isDateOpen, setIsDateOpen] = useState<boolean>(false)
  const openDatePicker = () => {
    setIsDateOpen(true)
  }
  const closeDatePicker = () => {
    setIsDateOpen(false)
  }

  const textFieldStyles = {
    //@ts-ignore
    '& .Mui-disabled': { color: theme.palette.text.primary },
    '& .MuiInputBase-input': {
      //@ts-ignore
      color: theme.palette.text.primary,
      //@ts-ignore
      WebkitTextFillColor: theme.palette.text.primary,
      '--color': theme.palette.text.primary,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      //@ts-ignore
      color: theme.palette.text.primary,
      '--color': theme.palette.text.primary,
      bgcolor: 'background.defaultdim',
    },
  }
  return (
    <div>
      <Box
        mt={1}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        {optimization?.type === 'seo' && (
          <TextField
            sx={{ width: optimization?.followDate ? '50%' : '85%', ...textFieldStyles }}
            label="Opts"
            type="number"
            value={localValue}
            onChange={onChange}
            onBlur={onBlur}
            placeholder="# of Opts"
            inputProps={{ min: 0, max: 10 }}
            disabled={!isEditMode}
          />
        )}
        <TextField
          sx={textFieldStyles}
          label="Created At"
          type="string"
          value={formatDateTime(optimization?.createdAt ?? null)}
          // onChange={onChange}
          // onBlur={onBlur}
          placeholder="Created At"
          disabled={true}
        />

        {optimization?.type === 'insight' ? (
          //@ts-ignore
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker
              localeText={{ start: 'Start Date', end: 'End Date' }}
              value={[
                //@ts-ignore
                optimization.startDate ? dayjs(optimization.startDate) : null,
                //@ts-ignore
                optimization.endDate ? dayjs(optimization.endDate) : null,
              ]}
              //@ts-ignore
              onChange={(newValue: DateRange<Dayjs>) => {
                const [start, end] = newValue
                const startDate = start ? start.toDate() : null
                const endDate = end ? end.toDate() : null
                onDateRangeChange(startDate, endDate)
              }}
              slotProps={{
                textField: ({ position }) => ({
                  className: 'date-range-text-field',
                  error: !optimization.startDate || !optimization.endDate,
                  sx: {
                    bgcolor: 'background.defaultdim',
                    '& .Mui-disabled': { color: theme.palette.text.primary },

                    '& .MuiInputBase-input': {
                      //@ts-ignore
                      color: theme.palette.text.primary,
                      //@ts-ignore
                      WebkitTextFillColor: theme.palette.text.primary,
                      '--color': theme.palette.text.primary,
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                      //@ts-ignore
                      '--color': theme.palette.text.primary,
                    },
                  },
                }),
              }}
              sx={{
                width: '100%',
                '& .MuiMultiInputDateRangeField-separator': {
                  m: 0,
                },
                '& .MuiFormControl-root': {
                  m: 0,
                },
                '& .MuiInputBase-root': {
                  maxHeight: '56px',
                  m: 0,
                },
              }}
              disabled={!isEditMode}
            />
          </LocalizationProvider>
        ) : (
          optimization?.followDate && (
            <DatePickerEditMode
              open={isDateOpen}
              setOpen={setIsDateOpen}
              label={'Follow Up Date'}
              value={optimization.followDate ? dayjs(optimization.followDate) : null}
              onChange={newDate => {
                closeDatePicker()
                const dateString = newDate ? newDate.toISOString() : ''
                onUpdate('followDate', dateString)
              }}
              isEditMode={isEditMode}
            />
          )
        )}

        {optimization && isEditMode && <CancelContractButton onClick={onCancelEdit} isSaving={false} />}
        {optimization && isEditMode && <SaveIconButton hasErrors={false} onSave={onSave} />}
        {optimization && !isEditMode && <EditIconButton onEdit={onStartEdit} />}
      </Box>
      {optimization?.description && (
        <Box py={1}>
          <TextField
            className="opt-description"
            label={'Description'}
            fullWidth
            type="text"
            onChange={e => onUpdate('description', e.target.value)}
            value={optimization?.description || ''}
            placeholder="Description"
            multiline
            disabled={!isEditMode}
            sx={textFieldStyles}
          />
        </Box>
      )}
      {/* Editable Additional Notes Field */}
      <Box py={1}>
        {!isEditMode && (
          <InputLabel sx={{ textAlign: 'left', color: 'text.primary', fontSize: 12, ml: 1.4 }}>Addt'l Notes</InputLabel>
        )}
        <RichTextField
          content={addtlNotes || '<p></p>'}
          onContentChange={newValue => onUpdate('addtlNotes', newValue)}
          onBlur={() => {}}
          minHeight={'150px'}
          isEditMode={isEditMode}
        />
      </Box>
    </div>
  )
}
export default EditOptimizationFields
